import { Accordion as ChakraAccordion, Skeleton, Text } from '@chakra-ui/react'
import { FAQPageJsonLd } from 'next-seo'
import { ContainerWrapper } from '../../layout'
import { H2 } from '../../typography'
import AccordionItems, { AccordionElement } from './AccordionItems'

interface Props {
  title?: string | null
  introText?: string | null
  accordionItemsToRenderArray: AccordionElement[]
  isLoaded: boolean
  enableFaqStructuredData: boolean | null
}

// Extract text from rich text content
const extractTextFromRichText = (richTextContent: any): string => {
  if (!richTextContent) return ''

  let text = ''

  // If it's a text node, return its value
  if (richTextContent.nodeType === 'text') {
    return richTextContent.value || ''
  }

  // If it has content array, process each item
  if (richTextContent.content && Array.isArray(richTextContent.content)) {
    richTextContent.content.forEach((item: any) => {
      text += extractTextFromRichText(item)
    })
  }

  return text
}

const AccordionComponent = ({
  title,
  introText,
  accordionItemsToRenderArray,
  isLoaded,
  enableFaqStructuredData
}: Props) => {
  // Extract text from each accordion item's bodyText
  const accordionItemsWithText = accordionItemsToRenderArray.map((item) => {
    const richTextContent = item.bodyText?.props?.richText?.json
    const extractedText = richTextContent
      ? extractTextFromRichText(richTextContent)
      : ''

    // Add the item with it's title back with the extracted text.
    return {
      ...item,
      extractedText
    }
  })

  return (
    <ContainerWrapper>
      <Skeleton isLoaded={isLoaded}>
        {title && <H2 mb={{ base: 8, lg: 12 }}>{title}</H2>}
        {introText && (
          <Text
            fontSize={{ base: '20px', lg: '22px' }}
            lineHeight={{ base: '30px', lg: '36px' }}
          >
            {introText}
          </Text>
        )}
        <ChakraAccordion allowToggle maxW='1096px' mx='auto'>
          <AccordionItems
            accordionItemsToRenderArray={accordionItemsToRenderArray}
          />
        </ChakraAccordion>
      </Skeleton>
      {enableFaqStructuredData && (
        <FAQPageJsonLd
          mainEntity={accordionItemsWithText.map((item) => {
            return {
              questionName: String(item.title || ''),
              acceptedAnswerText: item.extractedText || ''
            }
          })}
        />
      )}
    </ContainerWrapper>
  )
}

export default AccordionComponent
